import React from 'react';

import { Form } from '@unform/web';
import { useFormik, FormikProvider } from 'formik';

import Select from '~/components/Formik/Select';
import { IProcess } from '~/store/modules/processes/types';
import { IFilterTaskParams } from '~/store/modules/tasks/types';

import { FilterTitle, SubmitFilterButton } from '../styles';

export interface FormTableData {
  processDefinitionNames?: string[];
}

interface FilterTasksFormProps {
  filterParams: IFilterTaskParams;
  onSubmit: (data: FormTableData) => void;
  processDefinitions?: IProcess[];
}

const FilterTasksForm: React.FC<FilterTasksFormProps> = ({
  filterParams,
  onSubmit,
  processDefinitions,
}) => {
  const initialValues: FormTableData = {
    processDefinitionNames: filterParams.processDefinitionNames,
  };

  const formik = useFormik({ initialValues, onSubmit });

  return (
    <FormikProvider value={formik}>
      <Form
        onSubmit={formik.handleSubmit}
        style={{
          margin: '1.143rem',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          gap: '1.143rem',
        }}
      >
        <div>
          <FilterTitle>Processo</FilterTitle>
          <Select
            name="processDefinitionNames"
            placeholder=""
            isClearable
            closeMenuOnSelect={false}
            options={processDefinitions?.map((process) => {
              return {
                value: process.name,
                label: process.name,
              };
            })}
            isMulti
          />
        </div>
        <SubmitFilterButton type="submit">Filtrar</SubmitFilterButton>
      </Form>
    </FormikProvider>
  );
};

export default FilterTasksForm;
